import React, { Component, Fragment } from 'react';
import logo from './logo.svg';
import shooting from './assets/shooting-star.svg';
import { Layout, Divider } from 'antd';
import Profile from './components/Profile'
import Competitions from './components/Competitions'
import Skills from './components/Skills'
import Github from './components/Github'
import PageFooter from './components/PageFooter'
import ScrollAnimation from 'react-animate-on-scroll';
import './App.css';

const { Header, Footer, Content } = Layout;

class App extends Component {

  state = {
    left: {},
    right: {}
  }

  constructor(props) {
    super(props)
    this.shootingStar = this.shootingStar.bind(this)
    this.cb = this.cb.bind(this)
  }

  shootingStar = (dir, cb) => {
    setInterval(() => {
      var topPos = Math.floor(Math.random() * 80) + 1,
        topPos = topPos + '%',
        leftPos = Math.floor(Math.random() * 40) + 1,
        leftPos = leftPos + '%',
        trans = Math.floor(Math.random() * 300) + 1,
        trans = trans + 'deg';
        cb(dir, {
            'top': topPos,
            [dir]: leftPos,
            transform: 'rotate(' + trans + ')'
          });
    }, 2000);
  }

  cb(dir, val) {
    this.setState({
      [dir] : val
    })
  }

  componentDidMount() {
    this.shootingStar('left',this.cb)
    this.shootingStar('right',this.cb)
  }
  
  render() {
    return (
      <Fragment>
        <Layout className="view trans py-5">
          <Content className="container">
              <ScrollAnimation animateIn="fadeIn">
                <Divider className="white-text">
                  <h3>POZTERZ'S PROFILE</h3>
                </Divider>
                <Profile />
              </ScrollAnimation>
          </Content>
            <Content className="trans py-5 my-3">
              <ScrollAnimation animateIn="fadeIn">
                <Skills />
              </ScrollAnimation>
            </Content >
          <Content className="white-bg py-5 my-3">
            <ScrollAnimation animateIn="fadeIn">
              <Competitions />
            </ScrollAnimation>
          </Content >
          <Content className="transpy-5 my-3">
            <ScrollAnimation animateIn="fadeIn">
              <Github />
            </ScrollAnimation>
          </Content >
          <div className="stars" />
          <div className="stars stars-lg" />
          <figure className="shooting-star" style={this.state.left}>
            <img src={shooting} />
          </figure>
          <figure className="shooting-star-right" style={this.state.right}>
            <img src={shooting} />
          </figure>
        </Layout>
        <ScrollAnimation animateIn="fadeIn">
          <Footer className="trans">
            <PageFooter />
          </Footer>
        </ScrollAnimation>
      </Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js